module.exports = __webpack_public_path__ + "static/media/homeleft.35e995ba.png";